import React, { Fragment } from 'react';

const NotificationsUsage = () => (
  <Fragment>
    <section>
      <article className="flex-justify-end flex-row last">
        <div className="left">
          <h1 className="h1 page-title">
            Notifications are messages that communicate information to the user.
          </h1>
        </div>
        <div className="right">
          <p>Notifications are components that appear on the screen at certain moments in time. It can be used to confirm an action, to inform the user about something or to ask him to complete a task. With all these options there was the need to create different kinds of notifications:</p>
        </div>
      </article>
    </section>
    <section className="bg-grey flex-grow-1 with-padding">
      <article className="flex-row flex-justify-end">
        <div className="right copy-content">
          <h2 className="h2 page-subtitle">Standard and With Icon</h2>
          <p>The standard notification, as well the notifications with an icon, are composed by different and independent elements, that work together and adapt to the needed context. The content’s section aligns to the right side of the page, always respecting the grid&#39;s limits.</p>
          <h2 className="h2 page-subtitle">Landing Notification</h2>
          <p>This type of notification is only informative and it&#39;s pinned to the top of the page, over the content of the page.</p>
          <h2 className="h2 page-subtitle">Featured Actions</h2>
          <p>The featured actions notification is used when a pending action or an important information must be evidenced. This notification is pinned to the page top and only disappears when the user interacts with it.</p>
        </div>
      </article>
    </section>
  </Fragment>
);

export default NotificationsUsage;


// WEBPACK FOOTER //
// ./src/containers/components/Notification/NotificationsUsage.js